import { Motoko, ICP } from './assets';

export const levelsImages = [Motoko, ICP];
export const levelTitles = ['web3 junior', 'web3 native'];
